import styles from './StepsRegistrationCedula.module.css';
import imageStep1 from '../../assets/img/create-account-step1-otp.jpg';
import imageStep2 from '../../assets/img/create-account-step2-cedula.jpg';
import imageStep3 from '../../assets/img/create-account-step3-cedula2.jpg';

export const StepsRegistrationCedula = () => {
  return (
    <div className={styles.cards}>
        <div className={styles.card}>
            <img src={imageStep1} alt='OTP' className={styles.card__image}/>
            <h4 className={styles.card__title}>Paso 1</h4>
            <p className={styles.card__description}>Ingresa la clave de un sólo uso (OTP) que llegará a tu celular.</p>
        </div>
        <div className={styles.card}>
            <img src={imageStep2} alt='Cedula Frontal' className={styles.card__image}/>
            <h4 className={styles.card__title}>Paso 2</h4>
            <p className={styles.card__description}>Toma una fotografía frontal de la cédula.</p>

        </div>
        <div className={styles.card}>
            <img src={imageStep3} alt='Cedula reverso' className={styles.card__image}/>
            <h4 className={styles.card__title}>Paso 3</h4>
            <p className={styles.card__description}>Toma una fotografía trasera de la cédula.</p>
        </div>
    </div>
  )
}
